import { render, staticRenderFns } from "./RaporAiGecmis.vue?vue&type=template&id=3dfb98ee&scoped=true"
import script from "./RaporAiGecmis.vue?vue&type=script&lang=ts"
export * from "./RaporAiGecmis.vue?vue&type=script&lang=ts"
import style0 from "./RaporAiGecmis.vue?vue&type=style&index=0&id=3dfb98ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb98ee",
  null
  
)

/* custom blocks */
import block0 from "./RaporAiGecmis.vue?vue&type=custom&index=0&blockType=v-list-item-action&class=flex-row%20align-center"
if (typeof block0 === 'function') block0(component)

export default component.exports